<template>
  <nav class="flex h-header">
    <ui-header-nav-item
      v-for="appRoute in headerNavBarRoutes"
      :key="appRoute.title"
      :route="appRoute"
      class="h-full"
      :is-active="activeRoute.startsWith(appRoute.link)"
    />
  </nav>
</template>

<script setup lang="ts">
import { RouteConfig } from '@/common';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';

const { t } = useI18n();
const route = useRoute();

const activeRoute = computed(() => route.path);

const headerNavBarRoutes = computed(() => {
  return [
    {
      title: t('3ZkeE9bKQrkO2Rich2ppu'),
      link: '/',
      routeType: 'internal',
    },
    // {
    //   title: t('rteN8e-eLrj-pOfcHJatu'),
    //   link: 'https://www.manitoba.ca/wildfire',
    //   routeType: 'external',
    // },
  ] as RouteConfig[];
});
</script>
